function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 1C5.889 1 1 5.889 1 12s4.889 11 11 11 11-4.889 11-11S18.111 1 12 1zm0 8.556c1.344 0 2.444 1.1 2.444 2.444 0 1.344-1.1 2.444-2.444 2.444A2.452 2.452 0 0 1 9.556 12c0-1.344 1.1-2.444 2.444-2.444zm3.422-2.445c0-.855.734-1.467 1.467-1.467.733 0 1.467.734 1.467 1.467 0 .733-.612 1.467-1.467 1.467-.856 0-1.467-.611-1.467-1.467zM12 20.556A8.503 8.503 0 0 1 3.444 12h3.667c0 2.689 2.2 4.889 4.889 4.889s4.889-2.2 4.889-4.889h3.667A8.503 8.503 0 0 1 12 20.556z"
});

var SvgIcSocialInstagramFilled = function SvgIcSocialInstagramFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcSocialInstagramFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_social_instagram_filled.16923b90.svg";
export { ForwardRef as ReactComponent };